import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getDailyReportAuthByUrl } from '../../apicalls/dailyReport';
import {
  DEFAULT_MESSAGE_INVALID_URL,
  DEFAULT_MESSAGE_UNEXPECTED_ERROR
} from '../../const/Const';
import { TSelectItem } from '../../types/common';
import { TConstructForWorkers } from '../../types/dailyReport';

export const useHooks = () => {
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const token = query.get('q');

  const [message, setMessage] = useState('');

  const [isLoading, setIsLoading] = useState(true);

  const [construct, setConstruct] = useState<TConstructForWorkers>({
    id: 0,
    name: ''
  });

  const [siteProcessList, setSiteProcessList] = useState<TSelectItem[]>([]);

  const showMessage = (message: string) => {
    setMessage(message);
  };

  const isAuthenticateError = (data: any) => {
    if (typeof data === 'string') {
      setMessage(data);
      return true;
    }
    if (data.error) {
      setMessage(data.error);
      return true;
    }
    if (!data.data) {
      setMessage(DEFAULT_MESSAGE_UNEXPECTED_ERROR);
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!token) {
      setMessage(DEFAULT_MESSAGE_INVALID_URL);
      setIsLoading(false);
      return;
    }

    getDailyReportAuthByUrl(token).then((data: any) => {
      if (isAuthenticateError(data)) {
        setIsLoading(false);
        return;
      }

      setConstruct(data.data.constructs);

      let list = [{ value: 0, label: '--' }];
      if (data.data.site_process_list) {
        list = list.concat(
          // レスポンスの工程リストをプルダウン用に加工
          // 親IDがある小工程は字下げする
          data.data.site_process_list?.map((process: any) => {
            return {
              value: process.id,
              label: `${process.parent_site_process_id ? '　' : ''}${
                process.name
              }`
            };
          })
        );
      }
      setSiteProcessList(list);
      setIsLoading(false);
    });
  }, []);

  return { isLoading, message, showMessage, construct, siteProcessList };
};
